import { partners } from "@/data/partners";
import PartnerRow from "./PartnerRow";

export default function PartnerDropdown() {
  return (
    <div className="top-full left-1/2 -translate-x-1/2 mt-2 w-[420px] bg-white rounded-xl shadow-xl border p-4 divide-y max-h-[400px] overflow-y-auto z-50">
      {partners.map((p) => (
        <PartnerRow key={p.name} partner={p} />
      ))}
    </div>
  );
}